import axios, { AxiosResponse } from 'axios'

import { getJwtToken } from './jwtToken'

export const apiClient = axios.create({
	baseURL: import.meta.env.VITE_API_BASE_URL,
})

export const apiGetRequest: <T1, T2 = T1[]>(
	path: string
) => Promise<T2> = async <T1, T2 = T1[]>(
	path: string
) => {
		const jwt = `Bearer ${await getJwtToken()}`
		const response = await apiClient.get(path, {
			headers: {
				Authorization: jwt
			}
		})
		return (response.data) as T2
	}

export const apiDeleteRequest: <T>(
	path: string,
) => Promise<AxiosResponse> = async (
	path: string,
) => {
		console.log("Deleting data")
		const jwt = `Bearer ${await getJwtToken()}`
		return await apiClient.delete(path, {
			headers: {
				Authorization: jwt,
			}
		})
	};

export const apiPostRequest: <T1, T2>(
	path: string,
	body: T1
) => Promise<T2> = async <T1, T2>(
	path: string,
	body: T1
) => {
		const jwt = `Bearer ${await getJwtToken()}`
		// Get signed s3 urls
		const response = await apiClient.post(path, body, {
			headers: {
				Authorization: jwt,
			}
		})
		return response.data as T2
	};

export const apiPutRequest: <T1, T2>(
	path: string,
	body: T1
) => Promise<T2> = async <T1, T2>(
	path: string,
	body: T1
) => {
		const jwt = `Bearer ${await getJwtToken()}`
		// Get signed s3 urls
		const response = await apiClient.put(path, body, {
			headers: {
				Authorization: jwt,
			}
		})
		return response.data as T2
	};

export const apiPatchRequest: <T, T2 = T[]>(
	path: string,
	data: T,
) => Promise<T2> = async <T, T2>(
	path: string,
	data: T,
) => {
		const jwt = `Bearer ${await getJwtToken()}`
		const response = await apiClient.patch(path, data, {
			headers: {
				Authorization: jwt,
			}
		})
		return response.data as T2
	};

export async function logCourseAction(appId: string, action: string, details: string) {
    try {
        const log = {
            id: crypto.randomUUID(),
            appId,
            timestamp: Date.now(),
            userEmail: 'Auto-filled by Backend',
            action,
            details
        };
        await apiPostRequest(`/logs/${appId}`, log);
    } catch (e) {
        console.error("Failed to log course action", e);
    }
}
